<template>
  <div class="body container">
    <!--导航-->
    <div class="nav clearfix">
      <a
        :class="{ active: column.id == columnid }"
        href="#"
        v-for="column in brotherColumnData"
        :key="column.id"
        @click="changeColumn(column.id, column.fix_column_name)"
        >{{ column.title }}</a
      >
    </div>

    <!--筛选-->
    <div class="selectWrap">
      <h4 class="tip">筛选</h4>
      <div class="selectBox">
        <div class="common">
          <span class="text">年级:</span>
          <div class="common-box">
            <a
              href="javascrpt:;"
              @click="search_grade(0)"
              :class="grade == 0 ? 'active' : ''"
              >全部</a
            >
            <a
              href="javascrpt:;"
              @click="search_grade(item.gradeid)"
              v-for="item in gradeData"
              :key="item.gradeid"
              :class="grade == item.gradeid ? 'active' : ''"
              >{{ item.gradename }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <!--班级空间列表-->
    <div class="content wrapper windowsBox">
      <div class="sortBox clearfix">
        <div class="sort fl">
          <a href="javascript:;">默认排序</a>
        </div>
      </div>

      <ul class="video clearfix">
        <li class="videoList" v-for="item in classData" :key="item.classid">
          <a class="cover" href="JavaScript:;" @click="toClassSpace(item)">
            <!-- <img src="../../assets/img/banji.png" /> -->
            <img :src="item.logo" :onerror="defaultClassImg" />
          </a>
          <div class="videoInfo">
            <a
              target="_blank"
              class="title"
              href="JavaScript:;"
              @click="toClassSpace(item)"
              >{{ item.cn_grade }}{{ item.class_no }}班</a
            >
          </div>
        </li>
      </ul>
      <div class="noData" v-if="nodata">
        <img src="../../assets/img/no_data.png" />
        <p>暂无数据，去别的地方看看吧~</p>
      </div>
      <div class="btnGroup">
        <div class="pagination">
          <el-pagination
            background
            hide-on-single-page
            @current-change="PageChange"
            layout="prev, pager, next"
            :total="count"
            :current-page="page"
            :page-size="pageSize"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
export default {
  name: "school_space_class",
  data() {
    return {
      columnid: this.$route.query.id, // 栏目id
      defaultClassImg:
        'this.src="' + require("../../assets/img/banji.png") + '"', // 图片损坏默认图
      page: 1,
      pageSize: 24,
      count: 0,
      grade: 0,
      classData: [], // 班级列表数据
      gradeData: [], // 年级列表数据
      brotherColumnData: [], // 二级导航数据
      nodata: false,
      grade_str: "",
      mark: "",
    };
  },

  components: {},

  computed: {
     globalVaranthasInited(){
         return globalApi.gWebsiteSessionInfo.hasInited;
     }
  },
  watch: {
      globalVaranthasInited: function(){        
        
        this.init();
      },
  },
  created() {
    
  },

  methods: {
    init(){
         this.getGrade();

         this.getBrotherColumn();
      },
      
      // 分页导航
    PageChange(val) {
      this.page = val;
      document.documentElement.scrollTop = 0;
      this.SearchSchoolClass();
    },

    // 获取二级导航
    async getBrotherColumn() {
      let data = {
        s: "WebSchoolSpace.Column.GetBrotherColumn",
        columnid: this.columnid,
        weblevel: 1,
        incdisabled: 1,
      };

      let res = await globalApi.post( data);
      this.brotherColumnData = res.data.data;
    },

    // 获取年级接口
    async getGrade() {
      const data = {
        s: "WebSchoolSpace.Common.getGrade",
      };
      const response = await globalApi.post( data);
      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }

      this.gradeData = res;
      let list = [];
      res.forEach((row) => {
        list.push(parseInt(row.gradeid));
      });
      this.grade_str = list.toString();
      this.SearchSchoolClass();
      this.mark = list.toString();
    },

    // 搜索年级
    search_grade(val) {
      if (val == 0) {
        this.grade = val;
        this.grade_str = this.mark;

        this.page = 1;
        this.SearchSchoolClass();
      } else {
        this.grade = val;
        this.grade_str = val;

        this.page = 1;
        this.SearchSchoolClass();
      }
    },

    // 获取班级接口
    async SearchSchoolClass() {
      const data = {
        s: "WebSchoolSpace.Zone.SearchSchoolClass",
        page: this.page,
        page_size: this.pageSize,
        grade: this.grade_str,
      };
      const response = await globalApi.post( data);

      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }

      this.classData = res.list;
      this.count = res.recordcount;
      this.nodata = this.count ? false : true;
    },

    // 二级导航跳转
    changeColumn(id, address) {
      this.$router.push(
        String(
          address + "?id=" + id + "&schoolid=" + this.$route.query.schoolid
        )
      );
    },

    // 跳转班级空间
    toClassSpace(item) {
      globalApi.jumpPath(6, "home", "classid=" + item.classid);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/index_body.scss";
</style>


